import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';

import {KpiState} from '../reducers/kpi.reducers';

const getError = (state: KpiState): any => state.error;

const getIsLoading = (state: KpiState): boolean => state.isLoading;

const getStats = (state: KpiState): any => state;

export const selectKpiState: MemoizedSelector<object, KpiState> = createFeatureSelector<KpiState>('KPI');

export const selectKpiError: MemoizedSelector<object, any> = createSelector(selectKpiState, getError);

export const selectKpiIsLoading: MemoizedSelector<object, boolean> = createSelector(selectKpiState, getIsLoading);

export const selectKpiStat = createSelector(selectKpiState, (state, props) => {
  if (state && state[props.tabName] && state[props.tabName][props.statName]) {
    return state[props.tabName][props.statName];
  } else {
    return null;
  }
  // return state ? state.stats[props.tab][props.statName] : null
});

export const selectKpiFetchTime = createSelector(selectKpiState, (state, props) =>
  state ? state.fetchTime[props.tab] : null,
);
